import { Link } from "react-router-dom";
import { BRAND, SOCIALS, COURSES, CONTACT } from "@/data/content";

const columns = [
  {
    title: "Explore",
    links: [
      { label: "Courses", to: "/courses" },
      ...COURSES.map((c) => ({ label: c.title, to: `/courses/${c.slug}` })),
      { label: "EnTrade", to: "/entrade" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "FAQ", to: "/faq" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms & Conditions", to: "/legal/terms" },
      { label: "Privacy Policy", to: "/legal/privacy" },
      { label: "Refund Policy", to: "/legal/refund" },
      { label: "Risk Disclosure", to: "/legal/risk-disclosure" },
    ],
  },
];

const Footer = () => (
  <footer data-testid="footer" className="relative bg-coal text-ivory grain overflow-hidden">
    <div className="container-x py-16 lg:py-24">
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-10">
        <div className="col-span-2">
          <p className="font-semibold text-xl tracking-tight">T Plus One</p>
          <p className="mt-4 text-sm text-[#A0A09C] leading-relaxed max-w-xs">{BRAND.tagline}</p>
          <div className="mt-6 space-y-2 text-sm text-[#A0A09C]">
            <p><a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="hover:text-ivory transition-colors">{CONTACT.email}</a></p>
            <p><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="hover:text-ivory transition-colors">{CONTACT.phone}</a></p>
            <p className="text-xs leading-relaxed text-[#8E8E8B] max-w-xs">{CONTACT.address}</p>
          </div>
          <div className="flex gap-5 mt-8">
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" data-testid={s.testid} className="text-xs font-mono uppercase tracking-[0.15em] text-[#8E8E8B] hover:text-ivory transition-colors">
                {s.label}
              </a>
            ))}
          </div>
        </div>
        {columns.map((col) => (
          <nav key={col.title} aria-label={col.title}>
            <p className="eyebrow-dark mb-5">{col.title}</p>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="text-sm text-[#A0A09C] hover:text-ivory transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>
      <div className="mt-16 pt-8 border-t border-coalline">
        <p className="text-xs text-[#8E8E8B] leading-relaxed max-w-3xl">{BRAND.riskDisclosure}</p>
        <p className="mt-6 text-xs text-[#64645f]">© 2026 T Plus One. All rights reserved.</p>
      </div>
      <div className="mt-14 -mb-6 lg:-mb-10 overflow-hidden" aria-hidden="true">
        <p className="stroke-text font-semibold leading-[0.85] tracking-tighter text-[18vw] lg:text-[13.5vw] whitespace-nowrap text-center">T Plus One</p>
      </div>
    </div>
  </footer>
);

export default Footer;
